import { render, staticRenderFns } from "./mart-list.vue?vue&type=template&id=7b2c84b0"
import script from "./mart-list.vue?vue&type=script&lang=js"
export * from "./mart-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports